<script>
import { Tabs, Tab, TabList, TabPanel } from "../Tabs/tabs";
import {orders, trigger} from '../stores/oders-store'
import { selectedAccount } from 'svelte-web3'
import Exchange from '../stores/Exchanage-contract-store'

let orderCancelling = false

//Canceling Open Orders

const cancelOrder = (id) => {
	$Exchange.methods.cancelOrder(id).send({ from: $selectedAccount, gas: "550000"})
	.on('transactionHash', (hash) => {
		orderCancelling = true
	})
	.on('receipt', (bla) => {
		trigger.event()
		orderCancelling = false
	})
	.on('error', (error) => {
		console.log(error)
		window.alert('There was an error!')
	})
}

</script>

{#if $orders}
    {#await $orders then }
        <Tabs>
            <TabList>
                <Tab>Trades</Tab>
                <Tab>Orders</Tab>
            </TabList>

            <TabPanel>
                <br />
                <table class="table table-dark table-md small Tabs">
                    <thead>
                        <tr>
                            <th class="date">Time</th>
                            <th>LTT</th>
                            <th>LTT/ETH</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $orders.myFilledOrdersList as order}
                            <tr>
                                <td class="text-muted date">{order.formattedTimestamp}</td>
                                <td class={`text-${order.orderTypeClass}`}>{order.orderSign}{order.tokenAmount}</td>
                                <td class={`text-${order.orderTypeClass}`}>{order.tokenPrice}</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </TabPanel>
            
            <TabPanel>
                {#if orderCancelling == false}
                <br />
                <table
                    class="table table-dark table-md small Tabs">
                    <thead>
                        <tr>
                            <th class="date">Time</th>
                            <th>Amount</th>
                            <th>LTT/ETH</th>
                            <th>Cancel</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $orders.myOpenOrdersList as order}
                            <tr key={order.id} class="align middle">
                                <td class="text-muted date">{order.formattedTimestamp}</td>
                                <td class={`text-${order.orderTypeClass}`}>{order.tokenAmount}</td>
                                <td class={`text-${order.orderTypeClass}`}>{order.tokenPrice}</td>
                                <td class="text-muted cancel-order" on:click = {cancelOrder(order.id)}>X</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
                {/if}
            </TabPanel>
        </Tabs>
    {/await}
{/if}